//import { LanguageRow } from "../../Administration";

//export function siteLanguageList() {
//    var result: string[][] = [];
//    for (var k of LanguageRow.getLookup().items) {
//        if (k.LanguageId !== 'en') {
//            result.push([k.Id.toString(), k.LanguageName]);
//        }
//    }
//    return result;
//}

import { LanguageRow } from "../../ServerTypes/Administration/LanguageRow";

export function getLanguageList() {
    return ((LanguageRow as any).getLookup().items as (LanguageRow[]))
        .filter(x => x.LanguageId != "en")
        .map(k => ({ id: k.LanguageId, text: k.LanguageName }));
}